export const SKULabelPrintFormat =  [
    {
      id: 1,
      IsActive: true,
      labelName: "Continuous feed (wide)",
    },
    {
      id: 2,
      IsActive: true,
      labelName: "Continuous feed",
    },
    {
      id: 3,
      IsActive: true,
      labelName: "Continuous dual (2x1)",
    },
    {
      id: 4,
      IsActive: true,
      labelName: "A4 Avery sheet of 3 X 11",
    },
    {
      id: 5,
      IsActive: true,
      labelName: "A4 Avery sheet of 5 X 13",
    },
    {
      id: 6,
      IsActive: true,
      labelName: "US Letter sheet of 3 X 10",
    },
    {
      id: 7,
      IsActive: true,
      labelName: "A4 sheet 4 X 14",
    },
    {
      id: 8,
      IsActive: true,
      labelName: "Rat-Tail",
    },
  ];